module.exports = __webpack_public_path__ + "static/media/siddharth-drink.bcfca3b5.jpg";